import { PropsSchedulerJobTable } from "@/pages/tax/extracao-nf-ofm/dtos/ofm-dtos";
import { invoiceModelLabel } from "@/pages/tax/extracao-nf-ofm/constants/const";

export default function OfmJobsTable({ rows, isLoading, emptyText = "Nenhum job encontrado", codInvoiceModel }: PropsSchedulerJobTable) {
  return (
    <div className="mt-2 border rounded-lg overflow-hidden">
      <div className="grid grid-cols-[80px_1fr_100px_140px_140px_160px] gap-3 px-3 py-2 bg-gray-50 text-xs text-gray-600">
        <div>Loja</div>
        <div>CNPJ</div>
        <div>Modelo</div>
        <div>Agendamento</div>
        <div>Status</div>
        <div>Finalizado</div>
      </div>

      {isLoading && rows.length === 0 && (
        <div className="p-4 text-sm text-gray-500">Carregando jobs…</div>
      )}

      {rows.map((j) => (
        <div key={j.id} className="grid grid-cols-[80px_1fr_100px_140px_140px_160px] gap-3 px-3 py-2 border-t text-sm">
          <div>{j.store ?? "-"}</div>
          <div className="truncate">{j.cnpj}</div>
          <div>{invoiceModelLabel(codInvoiceModel)}</div>
          <div className="truncate">{j.schedule_id ?? "-"}</div>
          <div>{j.status}</div>
          <div>{j.finished_at ? new Date(j.finished_at).toLocaleString("pt-BR") : "-"}</div>
        </div>
      ))}

      {!isLoading && rows.length === 0 && (
        <div className="p-4 text-sm text-gray-500">{emptyText}</div>
      )}
    </div>
  );
}
